import { jsx as _jsx } from "react/jsx-runtime";
import { clamp } from "lodash-es";
import { useFormatting } from "../formatting/useFormatting.js";
import { FormattedInput } from "./FormattedInput.js";
export const FormattedPriceInput = ({ value, min, max, multiplier = 1, onChange, ...props }) => {
    const { getFormattedPrice, getEditableFloat, getFloat } = useFormatting();
    function getFormattedValue(value) {
        if (value === null || value === undefined)
            return "";
        return getFormattedPrice(value * multiplier) ?? "";
    }
    function getEditableValue(value) {
        if (value === null || value === undefined)
            return "";
        return getEditableFloat(value * multiplier, false);
    }
    function getActualValue(value) {
        if (value === "")
            return null;
        const newValue = clamp(getFloat(value) / multiplier, min ?? Number.MIN_SAFE_INTEGER, max ?? Number.MAX_SAFE_INTEGER);
        return newValue;
    }
    return (_jsx(FormattedInput, { ...props, value: value, getFormattedValue: getFormattedValue, getActualValue: getActualValue, getEditableValue: getEditableValue, onChange: onChange }));
};
//# sourceMappingURL=FormattedPriceInput.js.map